import { WebShopRootProvider } from "@/src/providers";
import { NextLayoutProps } from "@/src/shared/models/components";
import {Source_Sans_3} from "next/font/google";
import { GoogleTagManager } from '@next/third-parties/google'
import {CookiesPanel} from "../../../CookiesPanel";

const inter = Source_Sans_3({
    weight: ["400", "600", "700"],
    style: "normal",
    subsets: ["cyrillic"],
    display: "swap",
});

const GTM_ID = process.env.GTM_ID;

export const AppRootLayout = ({ children }: NextLayoutProps) => {
    return (
        <html lang={"uk"} className={inter.className}>
            {
                GTM_ID?.length ? <GoogleTagManager gtmId={GTM_ID} /> : null
            }
            <WebShopRootProvider>
                <body id={"root"}>
                {children}
                <CookiesPanel />
                </body>
            </WebShopRootProvider>
        </html>
    );
};
